import React, { Component } from "react";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { connect } from "react-redux";
import { setDraggingItems, updateGroupList, setDragOverGroup } from "Store/GridLayout/action";
import { hasCardContainInGroups, getCardList, DragTypes, hasCheckedCardInAppGroup } from "../utilService";
import platform from "Pub/js/platform";
const { PubSub } = platform;
const noteSource = {
    beginDrag(props) {
        const cardList = getCardList(props.appGroupArr, props.id);
        props.setDraggingItems({
            from: DragTypes.SIDE_CARD,
            data: cardList,
        });
        return { type: "cardlist", cardList: cardList };
    },
    endDrag(props, monitor, component) {
        const dropResult = monitor.getDropResult();
        props.setDragOverGroup(null); //清空Grid dragOver状态
        if (monitor.didDrop()) {
            //拖到聚合应用清除已选card
            if ([DragTypes.APP_GROUP_ITEM, DragTypes.APP_GROUP].includes(dropResult.type)) {
                component.clearSelectedCards();
            }
        }
    },
};

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    };
}

class Item extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // Use empty image as a drag preview so browsers don't draw it
        // and we can draw whatever we want on the custom drag layer instead.
        this.props.connectDragPreview(getEmptyImage(), {
            // IE fallback: specify that we'd rather screenshot the node
            // when it already knows it's being dragged so we can hide it with CSS.
            captureDraggingState: true,
        });
        this.pubsub = PubSub.subscribe("onGridLayoutDropEnd", () => {
            this.clearSelectedCards();
        });
    }
    //SCU检测是否选中，是否在分组内存在
    shouldComponentUpdate(nextProps, nextState) {
        const { card } = this.props;
        if (this.props.checked !== nextProps.checked) {
            return true;
        }
        if (
            hasCardContainInGroups(this.props.groups, card.appid) !==
            hasCardContainInGroups(nextProps.groups, card.appid)
        ) {
            return true;
        }
        if (
            hasCheckedCardInAppGroup(this.props.appGroupMap, card.appid) !==
            hasCheckedCardInAppGroup(nextProps.appGroupMap, card.appid)
        ) {
            return true;
        }
        return false;
    }
    componentWillUnmount() {
        PubSub.unsubscribe(this.pubsub); //移除订阅
    }
    //改变SiderCard的选中状态
    onChangeChecked = e => {
        const checked = e.target.checked;
        const { index, parentIndex } = this.props;
        this.props.onChangeChecked(checked, parentIndex, index);
    };
    clickSiderCard = () => {
        const { index, parentIndex, checked } = this.props;
        this.props.onChangeChecked(!checked, parentIndex, index);
    };
    //清除card选中状态
    clearSelectedCards = () => {
        const { draggingItems, id } = this.props;
        const target = draggingItems.data.find(item => item.cardid === id);
        if (target) {this.props.resetSelectedCards();}
    };

    //搜索结果高亮关键字
    getCardName = name => {
        const { searchValue } = this.props;
        if (name.includes(searchValue)) {
            const index = name.indexOf(searchValue);
            const beforeStr = name.substr(0, index);
            const afterStr = name.substr(index + searchValue.length);
            return (
                <span>
                    {beforeStr}
                    <span>{searchValue}</span>
                    {afterStr}
                </span>
            );
        } else {
            return name;
        }
    };
    render() {
        const { connectDragSource, groups, name, checked, card } = this.props;
        const nameShow = this.getCardName(name);
        // isNotRepeat：不校验重复的，可添加多个
        const isAdded = card.isNotRepeat ? false : (hasCardContainInGroups(groups, card.appid) || hasCheckedCardInAppGroup(this.props.appGroupMap, card.appid));
        return connectDragSource(
            <div
                className="list-item-content"
                data-checked={checked}
                onClick={this.clickSiderCard}
                style={
                    checked
                        ? { border: '1px dashed #2563eb' }
                        : {
                            border:
                                window.nccColor == "black" ? "1px dashed transparent" : null,
                        }
                }
            >
                {isAdded ? (
                    <div
                        className={
                            checked ? `title isAddColor titleChecked` : `title isAddColor`
                        }
                    >
                        <span className="title-name">{nameShow}</span>
                    </div>
                ) : (
                    <div className={checked ? `title titleChecked` : `title`}>
                        <span className="title-name">{nameShow}</span>
                    </div>
                )}
                {checked ? (
                    <i
                        title={
                            this.props.json["DesktopSetting-000039"]
                        } /* 国际化处理： 卡片已选中*/
                        className="iconfont icon-peizhi_tianjia iconlocation"
                        style={{ color: "#2563eb" }}
                    />
                ) : (
                    <i
                        title={
                            this.props.json["DesktopSetting-000040"]
                        } /* 国际化处理： 卡片未选中*/
                        className="iconfont icon-peizhi_tianjia iconlocation unSelect"
                    />
                )}
            </div>,
        );
    }
}

const dragDropItem = DragSource(DragTypes.SIDE_CARD, noteSource, collectSource)(Item);

export default connect(
    state => ({
        groups: state.gridLayoutData.groups,
        json: state.gridLayoutData.json,
        draggingItems: state.gridLayoutData.draggingItems,
        appGroupMap: state.gridLayoutData.appGroupMap,
    }),
    {
        updateGroupList,
        setDraggingItems,
        setDragOverGroup,
    },
)(dragDropItem);
